export const SET_BUTTONS_ARRAY_POSITION = 'SET_BUTTONS_ARRAY_POSITION'
